import { BaseEntity } from '../../../models';

export class CidadeSubRegiaoBairro implements BaseEntity {
    readonly id: number;
    nome: string;
    idCidadeSubRegiao: number;
    classificacao: number;
}
